import { ArticleType } from './_quick-articles-static-data';

export function shuffleList(values: ArticleType[]) {
  return values
    .map((value) => ({ value, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .map(({ value }) => value);
}

export function cropList(list: ArticleType[], count: number) {
  return list.filter((_, i) => i < count);
}
